export const footers = [
  {
    header: 'দ্রুত লিংকসমূহ',
    description: [
      {
        title: 'আমাদের সম্পর্কে',
        ref: '/about',
      },
      {
        title: 'সাধারণ জিজ্ঞাসা',
        ref: '/faq',
      },
      {
        title: 'ডেলিভারি সেবা',
        ref: '/delivery-service',
      },
    ],
  },
  {
    header: 'জরুরী লিংকসমূহ',
    description: [
      {
        title: 'গোপনীয়তা নীতি',
        ref: '/privacy-policy',
      },
      {
        title: 'ব্যবহারের শর্তাবলী',
        ref: '/terms-and-conditions',
      },
    ],
  },
  {
    header: 'যোগাযোগ',
    description: [
      {
        title: 'contact@arektakichu.com',
        ref: 'mailto:contact@arektakichu.com',
      },
    ],
  },
];
